import { ExternalLinkIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  CheckboxGroup,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Radio,
  RadioGroup,
  SimpleGrid,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import React, { useState } from "react";
import { TbReportAnalytics } from "react-icons/tb";
import { UserAuth } from "../auth/AuthContext";

const ReportEvent = ({ filteredEvents, carroId, filialId }) => {
  const [selectedYear, setSelectedYear] = useState(moment().year());
  const [selectedMonths, setSelectedMonths] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const { user } = UserAuth();
  const url_atual = window.location.href;

  const handleMonthChange = (newMonth) => {
    let newSelectedMonths = [...selectedMonths];
    if (newSelectedMonths.includes(newMonth)) {
      newSelectedMonths = newSelectedMonths.filter(
        (month) => month !== newMonth
      );
    } else {
      newSelectedMonths.push(newMonth);
    }
    setSelectedMonths(newSelectedMonths);
  };

  const handleYearChange = (newYear) => {
    setSelectedYear(newYear);
  };

  let docDefinition;
  const eventos = filteredEvents ? filteredEvents.slice() : [];
  if (eventos) {
    // // Convert the date property of each event to a Date object
    eventos.forEach((event) => {
      event.date = new Date(event.date);
    });

    // // Sort the eventos array by the date property
    eventos.sort((event1, event2) => {
      return event1.date - event2.date;
    });

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const filteredEventsByMonthAndYear = eventos.filter((event) => {
      return (
        selectedMonths.includes(moment(event.date).month()) &&
        moment(event.date).year() === selectedYear
      );
    });
    const total = filteredEventsByMonthAndYear.reduce(
      (acc, event) => acc + event.valor,
      0
    );

    const formatter = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

    const reportTitle = [
      {
        text: `REGISTROS DO CARRO ID: ${carroId} - FILIAL: ${filialId} - TOTAL: ${formatter.format(
          total
        )}`,
        fontSize: 15,
        bold: true,
        alignment: "center",
        margin: [15, 20, 0, 45], //left, top, right, bottom
      },
    ];

    const dados = filteredEventsByMonthAndYear.map((event) => {
      return [
        { text: event.reason },

        { text: event.resumo, alignment: "justify" },
        {
          text: moment(event.createdAt.seconds * 1000).format(
            "DD/MM/YYYY HH:mm:ss"
          ),
          fillColor: "#dddddd",
          alignment: "center",
        },
        {
          text: moment.utc(event.date).locale("pt-br").format("L"),
          alignment: "center",
        },
        { text: event.criador, alignment: "center" },
        {
          text: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(event.valor),
        },
      ];
    });

    const details = [
      {
        table: {
          headerRows: 1,

          widths: ["*", 320, "*", "*", "*", "*"],
          body: [
            [
              {
                text: "MOTIVO",
                style: "tableHeader",
                fontSize: 13,
                bold: true,
                border: [true, true, true, true],
                fillColor: "#dddddd",
                alignment: "center",
              },
              {
                text: "RESUMO",
                style: "tableHeader",
                fontSize: 13,
                bold: true,
                border: [true, true, true, true],
                fillColor: "#dddddd",
                alignment: "center",
              },
              {
                text: "LANÇADO EM",
                style: "tableHeader",
                fontSize: 13,
                bold: true,
                border: [true, true, true, true],
                fillColor: "#dddddd",
                alignment: "center",
              },
              {
                text: "OCORREU EM",
                style: "tableHeader",
                fontSize: 13,
                bold: true,
                border: [true, true, true, true],
                fillColor: "#dddddd",
                alignment: "center",
              },
              {
                text: "USUÁRIO",
                style: "tableHeader",
                fontSize: 13,
                bold: true,
                border: [true, true, true, true],
                fillColor: "#dddddd",
                alignment: "center",
              },
              {
                text: "VALOR",
                style: "tableHeader",
                fontSize: 13,
                bold: true,
                border: [true, true, true, true],
                fillColor: "#dddddd",
                alignment: "center",
              },
            ],
            ...dados,
            [
              {
                text: "-",
                fontSize: 15,
                bold: true,
                fillColor: "#dddddd",
                alignment: "center",
              },
              {
                text: "-",
                fontSize: 15,
                bold: true,
                fillColor: "#dddddd",
                alignment: "center",
              },
              {
                text: "-",
                fontSize: 15,
                bold: true,
                fillColor: "#dddddd",
                alignment: "center",
              },
              {
                text: "-",
                fontSize: 15,
                bold: true,
                fillColor: "#dddddd",
                alignment: "center",
              },
              {
                text: "Total:",
                fontSize: 15,
                bold: true,
                fillColor: "#dddddd",
                alignment: "center",
              },
              {
                text: Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(total),
                fontSize: 15,
                bold: true,
                margin: [0, 2, 0, 2],
                fillColor: "#dddddd",
                alignment: "center",
              },
            ],
          ],
        },
        // layout: "lightHorizontalLines",
      },
      {
        qr: url_atual,
        fit: "100",
        alignment: "center",
        margin: [0, 30, 0, 0], //left, top, right, bottom
      },
    ];

    function Rodape(currentPage, pageCount) {
      return [
        {
          text: currentPage + "/" + pageCount,
          alignment: "right",
          fontSize: 9,
          margin: [0, 10, 20, 0],
        },
        {
          text: `Gerado pelo usuário ${user.displayName} na ${moment().format(
            "LLLL"
          )}`,
          alignment: "left",
          fontSize: 9,
          margin: [20, -10, 0, 0], //left, top, right, bottom
        },
        {
          text: `${url_atual}`,
          link: `${url_atual}`,
          alignment: "center",
          fontSize: 9,
          margin: [0, 4, 0, 0],
        },
      ];
    }

    const redColor = "#ff0000";

    docDefinition = {
      info: {
        title: `CARRO ID: ${carroId} DA FILIAL DE ${filialId}`,
      },
      fileName: `ID: ${carroId}, filial ${filialId}`,
      pageOrientation: "landscape",
      pageSize: "A4",
      pageMargins: [15, 50, 15, 0],

      header: [reportTitle],

      content: [
        {
          text: `ATENÇÃO, ESTE RELATÓRIO APRESENTA OS EVENTO LISTADOS PELA DATA QUE OCCOREU E NÃO PELA DATA EM QUE FOI LANÇADO, LANÇAMENTOS RETROATIVOS DEVEM SEREM EVITADOS!`,
          fontSize: 8,
          bold: true,
          alignment: "center",
          color: redColor,
          margin: [5, 0, 5, 5], //left, top, right, bottom
        },
        details,
      ],

      footer: Rodape,
    };
  } else {
    // console.log("ERRO AO GERAR");
  }
  const months = moment.months();
  const currentMonth = moment().format("MMMM");

  return (
    <>
      <Flex>
        <Button
          ref={btnRef}
          colorScheme="blue"
          onClick={onOpen}
          size="sm"
          leftIcon={<ExternalLinkIcon />}
        >
          Relatório por data do evento
        </Button>
        <Drawer
          isOpen={isOpen}
          placement="bottom"
          onClose={onClose}
          finalFocusRef={btnRef}
          size="lg"
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton color={"white"} />
            <DrawerHeader
              icon={<TbReportAnalytics />}
              bgGradient="linear(to-r, blue.500, green.500)"
              color={"white"}
            >
              <Flex align={"center"}>
                <TbReportAnalytics fontSize={40} />
                <Box pl={2}>
                  Gerar Relatório por{" "}
                  <Text color={"red.500"} as="b" background={"gray.100"}>
                    data do evento{" "}
                  </Text>
                </Box>
              </Flex>
            </DrawerHeader>
            <Divider colorScheme="blue" />
            <DrawerBody mb={40}>
              <RadioGroup defaultValue="ano1">
                <Stack spacing={5} direction={"row"} justifyContent="center">
                  <Radio
                    size="lg"
                    value="ano1"
                    onChange={() => handleYearChange(moment().year())}
                  >
                    {moment().format("YYYY")}
                  </Radio>
                  <Radio
                    size="lg"
                    value="ano2"
                    onChange={() => handleYearChange(moment().year() - 1)}
                  >
                    {moment().subtract(1, "years").format("YYYY")}
                  </Radio>
                  <Radio
                    size="lg"
                    value="ano3"
                    onChange={() => handleYearChange(moment().year() - 2)}
                  >
                    {moment().subtract(2, "years").format("YYYY")}
                  </Radio>
                  <Radio
                    size="lg"
                    value="ano4"
                    onChange={() => handleYearChange(moment().year() - 3)}
                  >
                    {moment().subtract(3, "years").format("YYYY")}
                  </Radio>
                </Stack>
              </RadioGroup>
              <Stack direction="row" h="20px" pt={2}>
                <Divider colorScheme="blue" />
              </Stack>
              <SimpleGrid columns={[2, null, 3]} spacing="5px">
                <CheckboxGroup colorScheme="green">
                  {months.map((month, index) => (
                    <Checkbox
                      size="lg"
                      key={month}
                      value={month}
                      onChange={() => handleMonthChange(index)}
                      isChecked
                    >
                      {month} ({index + 1})
                    </Checkbox>
                  ))}
                </CheckboxGroup>
              </SimpleGrid>
            </DrawerBody>
            <Stack direction={"row"} justifyContent="center">
              <Text>Hoje é {moment().format("LL")}</Text>
            </Stack>

            <DrawerFooter justifyContent={"center"}>
              <ButtonGroup mr={3}>
                <Button variant="outline" onClick={onClose}>
                  Fechar
                </Button>
                <Button
                  colorScheme="blue"
                  onClick={() =>
                    pdfMake
                      .createPdf(docDefinition)
                      .download(`CARRO ID: ${carroId} DA FILIAL DE ${filialId}`)
                  }
                >
                  Baixar (Celular)
                </Button>
                <Button
                  colorScheme="blue"
                  onClick={() => pdfMake.createPdf(docDefinition).open()}
                >
                  Ver (Pc)
                </Button>
              </ButtonGroup>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      </Flex>
    </>
  );
};

export default ReportEvent;
